import { useEffect, useState } from 'react';
import { useBangTongHopHoaDonBanHangHoaDichVuContext } from '../context';
import { initialValues, SearchFormValues } from '../schema';

export const useDialogState = () => {
  const [initialSearchDialogOpen, setInitialSearchDialogOpen] = useState(true);
  const [editPrintTemplateDialogOpen, setEditPrintTemplateDialogOpen] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const { queryParams, setQueryParams, searchFieldState, setSearchFieldState, exportToExcel } =
    useBangTongHopHoaDonBanHangHoaDichVuContext();
  const [searchParams, setSearchParams] = useState<SearchFormValues>(queryParams || initialValues);

  useEffect(() => {
    if (queryParams) {
      setSearchParams(queryParams);
    }
  }, [queryParams]);

  const handleInitialSearch = async (
    formData: SearchFormValues,
    getReport: (params: BanHangTableParams) => Promise<void>
  ) => {
    try {
      await getReport(formData);
      setSearchParams(formData);
      setQueryParams(formData);
      setInitialSearchDialogOpen(false);
      setShowTable(true);
      handleInitialSearchClose();
    } catch (e) {
      return;
    }
  };

  const handleRefreshClick = async (getReport: (params: BanHangTableParams) => Promise<void>) => {
    if (searchParams) {
      await getReport(searchParams);
    }
  };

  const handleInitialSearchClose = () => {
    setInitialSearchDialogOpen(false);
  };

  const handleSearchClick = () => {
    setInitialSearchDialogOpen(true);
  };

  const handleEditPrintTemplateClick = () => {
    setEditPrintTemplateDialogOpen(true);
  };

  const handleClosePrintTemplateDialog = () => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleSavePrintTemplate = (_template: BanHangPayload) => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleRowClick = (_row: BanHangRecord) => {};

  const handleFixedColumnsClick = () => {};

  return {
    // State
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,

    // Handlers
    handleInitialSearch,
    handleRefreshClick,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleRowClick,
    handleFixedColumnsClick,
    searchFieldState,
    setSearchFieldState
  };
};
